import React from 'react';
import styled from 'styled-components';
import { ProjectContainer, ProjectTitle, ProjectInfo } from './styles';
import { useLanguage } from '../../contexts/LanguageContext';

const ProjectDescription = styled.div`
  margin-bottom: 30px;
  line-height: 24px;
`;

const ProjectWrapper = styled.div`
  margin-bottom: 40px;
  
  h4 {
    font-size: 20px;
    color: #333;
    margin: 0 0 20px 0;
    font-weight: 600;
  }
  
  img {
    width: 100%;
    max-width: 600px;
    height: auto;
    margin-bottom: 20px;
    border: 1px solid #eee;
    
    &.gif {
      border-radius: 5px;
    }
  }
  
  .seeDemo {
    text-align: center;
    margin: 20px 0;
    
    a {
      background: #F34452;
      color: #FFF;
      padding: 12px 30px;
      text-decoration: none;
      text-transform: uppercase;
      font-weight: 600;
      border-radius: 3px;
      transition: all 0.3s;
      display: inline-block;
      
      &:hover {
        background: #d63946;
      }
    }
  }
  
  ul.list-inline {
    list-style: none;
    padding: 0;
    display: flex;
    gap: 20px;
    flex-wrap: wrap;
    
    li {
      b {
        color: #333;
      }
    }
  }
  
  .closeBtn {
    text-align: center;
    margin-top: 30px;
    
    button {
      background: #007bff;
      color: #FFF;
      border: none;
      padding: 12px 25px;
      border-radius: 3px;
      cursor: pointer;
      font-weight: 600;
      transition: all 0.3s;
      
      &:hover {
        background: #0056b3;
      }
      
      i {
        margin-right: 8px;
      }
    }
  }
`;

interface ProjectSupplyProps {
}

const ProjectSupply: React.FC<ProjectSupplyProps> = () => {
  const { t } = useLanguage();
  
  return (
    <ProjectContainer>
      <ProjectTitle>
        <h2>{t('supply.title')}</h2>
        <p className="tags">{t('supply.role')}</p>
      </ProjectTitle>
      
      <ProjectDescription>
        {t('supply.description1')} <br/>
        {t('supply.description2')}
      </ProjectDescription>
      
      <ProjectInfo>
        <p><b>{t('supply.roleLabel')}</b> {t('supply.myRole')}</p>
        <p><b>{t('supply.skillsLabel')}</b> {t('supply.skillsUtilized')}</p>
      </ProjectInfo>

      <ProjectWrapper>
        <h4>{t('supply.projectTitle')}</h4>
        <div className="seeDemo">
          <a href="http://supplyhouse.com" target="_blank" rel="noopener noreferrer">{t('supply.seeNewWebsites')}</a>
        </div>
        <img loading="lazy" decoding="async" src="/images/projects/supply.gif" className="img-responsive gif" alt="supply"/>
      </ProjectWrapper>

      <ProjectWrapper>
        <ul className="list-inline">
          <li><b>{t('supply.dateLabel')}</b> {t('supply.dateRange')}</li>
        </ul>
      </ProjectWrapper>
    </ProjectContainer>
  );
};

export default ProjectSupply;